export default __webpack_public_path__ + "static/media/sell.46d04b3b.png";